module.exports = __webpack_public_path__ + "static/video02-6939d76659fc568af49eec6f3a972505.png";